<template>
  <transition name="fade-info">
    <div v-if="isMiniCartActive" class="mini-cart mini-cart__wrapper" :class="[{active: isMiniCartActive}, {'null': cartCount === 0}]">
        <div class="mini-cart__wrap" v-if="cartCount > 0">
            <div class="mini-cart__container">
                <div class="mini-cart__header">
                <h4 class="mini-cart__title">
                    {{ $t("Shopping Cart") }}
                </h4>
                <a class="mini-cart__header-link" href="/cart/index">
                    {{ $t("View cart") }}
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.317 10.5419C13.317 10.751 13.2372 10.96 13.0778 11.1194L8.06136 16.1359C7.74225 16.455 7.22487 16.455 6.90589 16.1359C6.58691 15.8169 6.58691 15.2996 6.90589 14.9805L11.3447 10.5419L6.90605 6.10325C6.58707 5.78414 6.58707 5.26692 6.90605 4.94796C7.22503 4.6287 7.74241 4.6287 8.06152 4.94796L13.078 9.9643C13.2373 10.1238 13.317 10.3329 13.317 10.5419Z" fill="currentColor"/>
                    </svg>
                </a>
                </div>
                    <div class="mini-cart__products-list mini-cart-mob__products-list list-items">
                        <div class="mini-cart__product-item item" v-for="product in products" :key="product.id">
                            <div class="mini-cart__product-img">
                                <img :src="product.product.images.icon.src" :alt="product.product.images.icon.alt" :title="product.product.images.icon.title">
                            </div>
                            <div class="mini-cart__product-info-wrap">
                            <div class="mini-cart__product-info-item">
                                <div class="mini-cart__product-text">
                                    <h4 class="mini-cart__product-title">{{ product.name }}</h4>
                                    <div class="mini-cart__product-delete" @click="deleteFromMiniCart(product.id, product.data_info)">
                                        <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.458 9.444L19.1429 19.1939C19.1161 20.029 18.7721 20.8204 18.1839 21.4003C17.5957 21.9803 16.8096 22.303 15.9925 22.3H10.0067C9.19012 22.303 8.40451 21.9807 7.81639 21.4015C7.22828 20.8223 6.8839 20.0316 6.85626 19.1972L6.54122 9.444C6.53432 9.23041 6.61069 9.02278 6.75353 8.86677C6.89636 8.71076 7.09395 8.61916 7.30284 8.61211C7.51172 8.60506 7.71479 8.68315 7.86737 8.82919C8.01995 8.97523 8.10954 9.17726 8.11643 9.39085L8.43148 19.1432C8.44717 19.5595 8.62003 19.9534 8.91375 20.2422C9.20748 20.531 9.59922 20.6921 10.0067 20.6918H15.9925C16.4005 20.6921 16.7927 20.5305 17.0865 20.241C17.3803 19.9516 17.5528 19.5569 17.5677 19.14L17.8828 9.39085C17.8897 9.17726 17.9793 8.97523 18.1318 8.82919C18.2844 8.68315 18.4875 8.60506 18.6964 8.61211C18.9053 8.61916 19.1029 8.71076 19.2457 8.86677C19.3885 9.02278 19.4649 9.23041 19.458 9.444ZM20.5 6.19939C20.5 6.41297 20.417 6.6178 20.2693 6.76883C20.1216 6.91986 19.9213 7.0047 19.7124 7.0047H6.28761C6.07872 7.0047 5.87839 6.91986 5.73068 6.76883C5.58298 6.6178 5.5 6.41297 5.5 6.19939C5.5 5.9858 5.58298 5.78097 5.73068 5.62994C5.87839 5.47892 6.07872 5.39407 6.28761 5.39407H8.72919C8.97875 5.39476 9.21962 5.30049 9.40495 5.12961C9.59027 4.95872 9.70679 4.72345 9.73182 4.46957C9.78994 3.87403 10.0628 3.32194 10.4973 2.92088C10.9318 2.51981 11.4967 2.2985 12.082 2.30006H13.9172C14.5025 2.2985 15.0674 2.51981 15.5019 2.92088C15.9364 3.32194 16.2093 3.87403 16.2674 4.46957C16.2924 4.72345 16.4089 4.95872 16.5943 5.12961C16.7796 5.30049 17.0205 5.39476 17.27 5.39407H19.7116C19.9205 5.39407 20.1208 5.47892 20.2685 5.62994C20.4162 5.78097 20.4992 5.9858 20.4992 6.19939H20.5ZM11.0991 5.39407H14.9017C14.7982 5.15227 14.7305 4.89605 14.7008 4.63386C14.6813 4.43535 14.5904 4.25132 14.4458 4.11742C14.3012 3.98351 14.1131 3.90927 13.918 3.90907H12.0828C11.8877 3.90927 11.6996 3.98351 11.555 4.11742C11.4103 4.25132 11.3195 4.43535 11.2999 4.63386C11.27 4.8961 11.2029 5.15232 11.0991 5.39407ZM11.8922 17.5954V10.7381C11.8922 10.5246 11.8092 10.3197 11.6615 10.1687C11.5138 10.0177 11.3135 9.93282 11.1046 9.93282C10.8957 9.93282 10.6954 10.0177 10.5477 10.1687C10.4 10.3197 10.317 10.5246 10.317 10.7381V17.5986C10.317 17.8122 10.4 18.017 10.5477 18.168C10.6954 18.3191 10.8957 18.4039 11.1046 18.4039C11.3135 18.4039 11.5138 18.3191 11.6615 18.168C11.8092 18.017 11.8922 17.8122 11.8922 17.5986V17.5954ZM15.6838 17.5954V10.7381C15.6838 10.5246 15.6008 10.3197 15.4531 10.1687C15.3054 10.0177 15.1051 9.93282 14.8962 9.93282C14.6873 9.93282 14.4869 10.0177 14.3392 10.1687C14.1915 10.3197 14.1086 10.5246 14.1086 10.7381V17.5986C14.1086 17.8122 14.1915 18.017 14.3392 18.168C14.4869 18.3191 14.6873 18.4039 14.8962 18.4039C15.1051 18.4039 15.3054 18.3191 15.4531 18.168C15.6008 18.017 15.6838 17.8122 15.6838 17.5986V17.5954Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="mini-cart__controls-wrap">
                                    <div class="mini-cart__calculator-wrap">
                                        <p class="mini-cart__product-price mini-cart__text">{{ formatCurrency(product.cost) }}</p>
                                        <div class="card-calculator__calculator count-row" data-tag-tracking="removeFromCart">
                                            <a class="card-calculator__calculator-btn card-calculator__calculator-btn--minus" @click="miniCartBtnCount(product.id, product.quantity, product.min_order_quantity, product.stock, 'minus')">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.7174 10.7493H6.2826C6.21883 10.7493 6.16666 10.8014 6.16666 10.8652V11.7348C6.16666 11.7985 6.21883 11.8507 6.2826 11.8507H16.7174C16.7811 11.8507 16.8333 11.7985 16.8333 11.7348V10.8652C16.8333 10.8014 16.7811 10.7493 16.7174 10.7493Z" fill="currentColor"/>
                                                </svg>
                                            </a>
                                            <input
                                                class="card-calculator__calculator-input count"
                                                name="amount"
                                                type="number"
                                                :value="product.quantity"
                                            />
                                            <a class="card-calculator__calculator-btn card-calculator__calculator-btn--plus" @click="miniCartBtnCount(product.id, product.quantity, product.min_order_quantity, product.stock, 'plus')">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16.7174 10.7493H6.2826C6.21883 10.7493 6.16666 10.8014 6.16666 10.8652V11.7348C6.16666 11.7985 6.21883 11.8507 6.2826 11.8507H16.7174C16.7811 11.8507 16.8333 11.7985 16.8333 11.7348V10.8652C16.8333 10.8014 16.7811 10.7493 16.7174 10.7493Z" fill="currentColor"/>
                                                    <path d="M10.9492 6.08258V16.5174C10.9492 16.5811 11.0014 16.6333 11.0652 16.6333H11.9347C11.9985 16.6333 12.0507 16.5811 12.0507 16.5174V6.08258C12.0507 6.01881 11.9985 5.96663 11.9347 5.96663H11.0652C11.0014 5.96663 10.9492 6.01881 10.9492 6.08258Z" fill="currentColor"/>
                                                </svg>
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>

                    <div class="mini-cart__footer">
                    <div class="mini-cart__price">
                        <p class="mini-cart__total-text">{{ $t("Total") }}:</p>
                        <p class="mini-cart__cost-text">{{ formatCurrency(cartCost) }}</p>
                    </div>
                    <a class="mini-cart__footer-link" href="/cart/checkout" @click.prevent="handleCheckoutClick">
                        {{ $t("Go to Checkout") }}
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.317 10.5419C13.317 10.751 13.2372 10.96 13.0778 11.1194L8.06136 16.1359C7.74225 16.455 7.22487 16.455 6.90589 16.1359C6.58691 15.8169 6.58691 15.2996 6.90589 14.9805L11.3447 10.5419L6.90605 6.10325C6.58707 5.78414 6.58707 5.26692 6.90605 4.94796C7.22503 4.6287 7.74241 4.6287 8.06152 4.94796L13.078 9.9643C13.2373 10.1238 13.317 10.3329 13.317 10.5419Z" fill="currentColor"/>
                        </svg>
                    </a>

                    </div>
            </div>
        </div>

    </div>
  </transition>
</template>
  
<script>
import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
  
  export default {
    name: 'MiniCart',
    emits: ['close-mini-cart', 'modal-region-show'],
    components: {
      ScrollFade
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        isUserSeller: {
            type: Boolean,
            default: false,
        },
        isShowRegionModal: {
            type: Boolean,
            default: false,
        },
        cartDataProp: {
            type: Object,
            default: () => {},
        },
        isMiniCartActive: {
            type: Boolean,
            default: false,
        },
        isGuest: {
            type: Boolean,
            default: false,
        }
    },
    data() {
      return {
        cartCount: this.cartDataProp?.count,
        cartCost: this.cartDataProp?.total,
        cartDiscountCost: this.cartDataProp?.discount_cost || 0,
        products: this.cartDataProp?.items,
        currency: window.common.currency.symbol
      };
    },
    methods: {
        closeMiniCart() {
            this.$emit('close-mini-cart');
        },
        handleCheckoutClick() {
            if (this.isGuest) {
                window.location.href = '/checkout';
                return;
            }
            if (this.isShowRegionModal) {
                this.$emit('modal-region-show');
            } else {
                window.location.href = '/checkout';
            }
        },
        formatCurrency(amount, minAmount = 1) {
            const basePrice = minAmount * amount;
            let formatted = Number(basePrice)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                .replace(',', '.');

            return `${this.currency} ${formatted}`
        },
        deleteFromMiniCart(id, dataInfo) {
            if(this.cartCount === 1) {
                this.$emit('close-mini-cart');
            }
            window.updateMiniCarts(0, id, false);
            window.tagTracking("removeFromCart", dataInfo)
        },
        miniCartBtnCount(id, count, minCount, maxCount, btn) {
            let newCount = null;
            count = parseFloat(count);
            if(btn === 'minus') {
                newCount = count-1;
                if(newCount < minCount) {
                    newCount = minCount
                    return
                }
            } else if (btn === 'plus') {
                newCount = count+1;
                if(maxCount < newCount) {
                    newCount = maxCount
                    return
                }
            }

            if(newCount === 0 && this.cartCount === 1) {
                this.$emit('close-mini-cart');
            }

            window.updateMiniCarts(newCount, id, false);
        }
    },
    watch: {
        cartDataProp() {
            this.cartCost = this.cartDataProp.total;
            this.cartDiscountCost = this.cartDataProp?.discount_cost;
            this.products = this.cartDataProp.items;
            this.cartCount = this.cartDataProp.count;
            if(this.cartCost === this.cartDiscountCost) {
                this.cartDiscountCost = null;
            }
        }
    }
  };
</script>

<style lang="css" scoped>
    .fade-info-enter-active,
    .fade-info-leave-active {
        transition: opacity 0.4s ease;
    }

    .fade-info-enter-from,
    .fade-info-leave-to {
        opacity: 0;
    }

    .fade-info-enter-to,
    .fade-info-leave-from {
        opacity: 1;
    }
</style>